module.exports = __webpack_public_path__ + "static/img/zygkbg.29e7cd57.png";